import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { UserSettingsPage } from '@/areas/settings/OrganizationSettings/pages/UserSettingsPage';
import { canViewUserManagementUsers } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/users/')({
    staticData: { access: { permissions: canViewUserManagementUsers }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <UserSettingsPage />;
}
